import { MerlinActionTypes } from './merlin.types';

const requestMerlinToken = () => ({ type: MerlinActionTypes.MERLIN_GENERATE_TOKEN });
const merlinTokenSuccess = token => ({ type: MerlinActionTypes.MERLIN_GENERATE_TOKEN_SUCCESS, payload: { token } });
const merlinTokenFail = () => ({ type: MerlinActionTypes.MERLIN_GENERATE_TOKEN_FAIL });
const merlinSetUrl = url => ({ type: MerlinActionTypes.MERLIN_SET_URL, payload: { url } });
const setChatData = ({ chatId, cookieName, isIframeOpen }) => ({ type: MerlinActionTypes.MERLIN_SET_CHAT_DATA, payload: { chatId, cookieName, isIframeOpen } });
const merlinReset = () => ({ type: MerlinActionTypes.MERLIN_RESET });

const merlinActions = {
  requestMerlinToken,
  merlinTokenSuccess,
  merlinTokenFail,
  merlinSetUrl,
  merlinReset,
  setChatData,
};

export default merlinActions;
